export const primaryDark = '#43204c';